import React, { Fragment, useState, memo } from 'react';
import { Card, CardBody, Row } from 'reactstrap';
import moment from 'moment';
import HeroCard from './ChatComponent/HeroCard';
import LinkItem from './ChatComponent/LinkItem';
import ButtonItem from './ChatComponent/ButtonItem';
import SuggestionButtonItem from './ChatComponent/SuggestionButton';
import ImageCarousel from './ChatComponent/ImageCarousel';
import HeroCardCarousel from './ChatComponent/HeroCardCarousel';
import VideoCarousel from './ChatComponent/VideoCarousel';
import AudioCarousel from './ChatComponent/AudioCarousel';
import Feedback from './ChatComponent/Feedback';
// import Linkify from 'linkify-react';
import agentIcon from '../../assets/bot_icon.png';
import { Colxx, Separator } from '../common/CustomBootstrap';
import { AxiosAPI } from '../../helpers/AxiosAPI';
import { postAPI_DownloadMedia } from '../../constants/APIs';
import {
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NotificationManager } from '../common/react-notifications';
import useTranslate from '../../helpers/useTranslate';
import Translate from '../../helpers/Translate';
import { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
// import 'moment-timezone';
// moment.tz.setDefault("Pacific/Auckland")

const ChatMessage = ({
  sender,
  channel,
  item,
  metadata,
  avatar,
  colors,
  translateLang,
  isTranslate,
}) => {
  const [blobUrl, setBlob] = useState();
  const [translateLocale, setTranslateLocale] = useState('');
  const [isTrans, setIsTrans] = useState(false);
  const translatedMessage = useTranslate(
    item?.text,
    translateLocale,
    isTrans
  );
  const translatedFeedback = useTranslate(
    item?.leaveFeedback,
    translateLocale,
    isTrans
  );
  useEffect(() => {
    if (translateLocale !== translateLang && isTranslate === true) {
      setTranslateLocale(translateLang);
      setIsTrans(true);
    }
  }, [translateLang]);

  const customEmailDecorator = ({ attributes, content }) => {
    return (
      <a href={attributes.href} style={{ color: '#1890ff !important' }}>
        {content}
      </a>
    );
  };

  const customPhoneDecorator = ({ attributes, content }) => {
    return (
      <a href={`tel:${content}`} className="customPhone">
        {content}
      </a>
    );
  };

  const customLinkDecorator = ({ attributes, content }) => {
    return (
      <a
        href={attributes.href}
        target="_blank"
        rel="noopener"
        className="customLink"
      >
        {content}
      </a>
    );
  };

  const linkifyOptions = {
    formatHref: {
      email: (href) => `mailto:${href}`,
      tel: (href) => `tel:${href}`,
      url: (href) => href,
    },
    render: {
      email: customEmailDecorator,
      tel: customPhoneDecorator,
      url: customLinkDecorator,
    },
  };

  const downloadMedia = (fileName, type, shortName) => {
    NotificationManager.success(
      '',
      'Please wait, it will take a few moments to download the document',
      3000,
      null,
      null,
      'success'
    );
    AxiosAPI({
      method: 'post',
      url: `${postAPI_DownloadMedia}`,
      data: {
        container: 'email-attachments',
        fileName: fileName,
      },
    }).then(
      (res) => {
        let link = document.createElement('a');
        const mimeType = type;
        link.href = `data:application/octet-stream;base64,${res.data.content}`;
        link.download = `${shortName}`;
        link.click();
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const renderMarkdown = (text) => {
    if (!text || typeof text !== 'string') return null;
    let content = text
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/【[^】]*?†([^】\s]+)】/g, '$1')
      .replace(/【[^】]*?†([^\s【】*]+)\*\*/g, '$1')
      .replace(/\b\d+:\d+†([^\s【】]+)/g, '$1')
      .replace(/[【】]/g, '')
      .replace(/%%BOLD%%(.+?)\*\*/g, '**$1**')
      .replace(/\*\*(.+?)%%BOLD%%/g, '**$1**')
      .replace(/%%BOLD%%/g, '**')
      .replace(/\*\*([^*\n>]+)\*\*/g, '%%BOLD%%$1%%BOLD%%')
      .replace(/\*\*/g, '')
      .replace(/%%BOLD%%/g, '**')
      .replace(/%%BOLD%%([^%]+)%%BOLD%%/g, '**$1**')
      .replace(/^([^(\n]*)(\s*)\)(\s*)$/gm, '$1')
      .replace(/^ {4}/gm, '')
      .trim();
    return (
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    );
  };
  return (
    <Fragment>
      {channel === 'EmailDirectLine' ? (
        <Fragment>
          {sender === true ? (
            <div className="tawk-avatar tawk-message-profile tawk-flex-none">
              <div className="tawk-avatar-image">
                <i className="iconsminds-female-2"></i>
              </div>
            </div>
          ) : null}
        </Fragment>
      ) : (
        <Fragment>
          {sender === true ? (
            <div className="tawk-avatar tawk-message-profile tawk-flex-none">
              <div className="tawk-avatar-image">
                <img
                  src="https://bmbuiassetsprod.blob.core.windows.net/images/chatgender.png"
                  alt="image"
                />
              </div>
            </div>
          ) : null}
        </Fragment>
      )}

      {(() => {
        switch (item.type) {
          case 'messages':
            return (
              <Card
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                style={{
                  backgroundColor:
                    sender !== true ? colors.botBot : colors.botUser,
                  color:
                    sender !== true ? colors.botBotText : colors.botUserText,
                }}
              >
                <div
                  className="position-absolute pt-1 pr-2 r-0"
                  style={{ top: '0' }}
                >
                  <span className="text-extra-small">
                    {moment(item.time).format('MMM DD, YYYY h:mm a')}
                  </span>
                </div>

                <CardBody>
                  <div className="chat-text-left">
                    <div className="mb-0">
                      {renderMarkdown(
                        isTrans
                          ? translatedMessage || item?.text
                          : item?.text
                      )}
                    </div>
                  </div>
                </CardBody>
                {sender !== true && item.text.length > 50 && (
                  <Feedback feedback={item.feedback}></Feedback>
                )}
              </Card>
            );
          case 'Suggest':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
              >
                <ButtonItem
                  item={item}
                  colors={colors}
                  time={item.time}
                  feedback={sender !== true ? item.feedback : ''}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></ButtonItem>
              </div>
            );
          case 'ImageCarousel':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                style={{
                  backgroundColor:
                    sender !== true ? colors.botBot : colors.botUser,
                  color:
                    sender !== true ? colors.botBotText : colors.botUserText,
                }}
              >
                <div className="pt-1 pr-2 r-0 text-right" style={{ top: '0' }}>
                  <span className="text-extra-small">
                    {moment(item.time).format('DD/MM/YYYY h:mm a')}
                  </span>
                </div>
                <ImageCarousel
                  sildes={item}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></ImageCarousel>
                {sender !== true && (
                  <Feedback feedback={item.feedback}></Feedback>
                )}
              </div>
            );
          case 'Link':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
              >
                <div className="pt-1 pr-2 r-0 text-right" style={{ top: '0' }}>
                  <span className="text-extra-small">
                    {moment(item.time).format('DD/MM/YYYY h:mm a')}
                  </span>
                </div>
                <LinkItem
                  linkItems={item}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></LinkItem>
                {sender !== true && (
                  <Feedback feedback={item.feedback}></Feedback>
                )}
              </div>
            );
          case 'SuggestionsButtons':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
              >
                <SuggestionButtonItem
                  item={item}
                  colors={colors}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></SuggestionButtonItem>
              </div>
            );
          case 'HeroCard':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3`}
                style={{
                  backgroundColor:
                    sender !== true ? colors.botBot : colors.botUser,
                  color:
                    sender !== true ? colors.botBotText : colors.botUserText,
                }}
              >
                <div className="pt-1 pr-2 r-0 text-right" style={{ top: '0' }}>
                  <span className="text-extra-small">
                    {moment(item.time).format('DD/MM/YYYY h:mm a')}
                  </span>
                </div>
                <HeroCard
                  sender={sender}
                  color={colors}
                  item={item.text}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></HeroCard>
                {sender !== true && (
                  <Feedback feedback={item.feedback}></Feedback>
                )}
              </div>
            );
          case 'HeroCardCarousel':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                style={{
                  backgroundColor:
                    sender !== true ? colors.botBot : colors.botUser,
                  color:
                    sender !== true ? colors.botBotText : colors.botUserText,
                }}
              >
                <div className="pt-1 pr-2 r-0 text-right" style={{ top: '0' }}>
                  <span className="text-extra-small">
                    {moment(item.time).format('DD/MM/YYYY h:mm a')}
                  </span>
                </div>
                <HeroCardCarousel
                  senders={sender}
                  sildes={item.text}
                  color={colors}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></HeroCardCarousel>
                {sender !== true && (
                  <Feedback feedback={item.feedback}></Feedback>
                )}
              </div>
            );
          case 'VideoCarousel':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                style={{
                  backgroundColor:
                    sender !== true ? colors.botBot : colors.botUser,
                  color:
                    sender !== true ? colors.botBotText : colors.botUserText,
                }}
              >
                <div className="pt-1 pr-2 r-0 text-right" style={{ top: '0' }}>
                  <span className="text-extra-small">
                    {moment(item.time).format('DD/MM/YYYY h:mm a')}
                  </span>
                </div>
                <VideoCarousel
                  sildes={item}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></VideoCarousel>
                {sender !== true && (
                  <Feedback feedback={item.feedback}></Feedback>
                )}
              </div>
            );
          case 'AudioCarousel':
            return (
              <div
                className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                  } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                style={{
                  backgroundColor:
                    sender !== true ? colors.botBot : colors.botUser,
                  color:
                    sender !== true ? colors.botBotText : colors.botUserText,
                }}
              >
                <div className="pt-1 pr-2 r-0 text-right" style={{ top: '0' }}>
                  <span className="text-extra-small">
                    {moment(item.time).format('DD/MM/YYYY h:mm a')}
                  </span>
                </div>
                <AudioCarousel
                  sildes={item}
                  translateLang={translateLocale}
                  isTranslate={isTrans}
                ></AudioCarousel>
                {sender !== true && (
                  <Feedback feedback={item.feedback}></Feedback>
                )}
              </div>
            );
          case 'message-email':
            return (
              <Fragment>
                <Card
                  className={`tawk-message-group-${sender !== false ? 'right' : 'left'
                    } tawk-flex-1 d-inline-block mb-3 conversationMessage`}
                  style={{
                    backgroundColor:
                      sender !== true ? colors.botBot : colors.botBot,
                    color:
                      sender !== true ? colors.botBotText : colors.botUserText,
                  }}
                >
                  <div
                    className="position-absolute pt-1 pr-2 r-0"
                    style={{ top: '0' }}
                  >
                    <span className="text-extra-small">
                      {moment(item.time).format('MMM DD, YYYY h:mm a')}
                    </span>
                  </div>

                  <CardBody>
                    <div className="chat-text-left">
                      {metadata !== undefined && (
                        <Fragment>
                          {metadata?.From && (
                            <p className="my-2">
                              <b>From</b>: {metadata.From}{' '}
                              {metadata?.FromEmail
                                ? '<' + metadata.FromEmail + '>'
                                : ''}
                            </p>
                          )}
                          {metadata?.Recipients && (
                            <p className="my-2">
                              <b>Recipients </b>: {metadata.Recipients}{' '}
                            </p>
                          )}
                          <Separator className="my-2"></Separator>
                        </Fragment>
                      )}
                      <div className="mb-0">
                        {renderMarkdown(
                          isTrans
                            ? translatedMessage || item?.text
                            : item?.text
                        )}
                      </div>
                      <br />
                      {metadata?.attachments &&
                        metadata.attachments.length > 0 && (
                          <Fragment>
                            {metadata.attachments.map((m) => (
                              <Row key={m?.fileName} className="mb-2 mx-1 download-file">
                                <Colxx md="10" className="download-file-text">
                                  <span className="">
                                    {isTrans === true ? (
                                      <Translate
                                        input={m?.shortName}
                                        lang={translateLocale}
                                      ></Translate>
                                    ) : (
                                      m?.shortName
                                    )}
                                  </span>
                                </Colxx>
                                <Separator className="seperate-line" />
                                <Colxx
                                  md="2"
                                  className="download-icon item-center"
                                >
                                  <FontAwesomeIcon
                                    icon={faDownload}
                                    onClick={() =>
                                      downloadMedia(
                                        m.fileName,
                                        m.type,
                                        m.shortName
                                      )
                                    }
                                  ></FontAwesomeIcon>{' '}
                                </Colxx>
                              </Row>
                            ))}
                          </Fragment>
                        )}
                    </div>
                  </CardBody>
                  {sender !== true && item?.text?.length > 50 && (
                    <Feedback feedback={item.feedback} />
                  )}
                </Card>
              </Fragment>
            );
          default:
            break;
        }
      })()}
      {item.type === 'SuggestionsButtons' || item.type === 'Suggest'
        ? (sender = true)
        : null}
      {channel === 'EmailDirectLine' ? (
        <Fragment>
          {sender === false ? (
            <div className="tawk-avatar tawk-message-profile tawk-flex-none">
              <div className="tawk-avatar-image">
                <i className="iconsminds-back"></i>
              </div>
            </div>
          ) : null}
        </Fragment>
      ) : (
        <Fragment>
          {sender === false ? (
            <div className="tawk-avatar tawk-message-profile tawk-flex-none">
              <div className="tawk-avatar-image">
                <img
                  src={item.source === 'Bot' ? avatar : agentIcon}
                  alt="Agent profile image"
                />
              </div>
            </div>
          ) : null}
        </Fragment>
      )}
      {item.leaveFeedback !== undefined &&
        item.leaveFeedback !== null &&
        item.leaveFeedback !== '' ? (
        <div
          className={`tawk-message-group-left tawk-flex-1 d-inline-block mb-3 conversationMessage`}
          style={{
            backgroundColor: colors.botUser,
            color: colors.botUserText,
            border: '1px solid red',
            borderRadius: '20px',
          }}
        >
          <div className="p-3">
            <div className="chat-text-left">
              <div className="mb-0">
                {renderMarkdown(
                  isTrans
                    ? translatedFeedback || item?.leaveFeedback
                    : item?.leaveFeedback
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="clearfix" />
    </Fragment>
  );
};

const MemoizedComponent = memo(ChatMessage);
export default MemoizedComponent;
